module.exports = __webpack_public_path__ + "static/media/app-store-btn.c57ab3a0.svg";